import * as React from 'react'
import UserCardIcon from '../../../../../../../assets/icons_new/UserCard.svg'

import { useNavigate, useLocation } from 'react-router-dom'
import { useDrivers } from '@/modules/shared/context/drivers/DriversContext'

import TableTextRow from '@/modules/drivers/shared/tableItems/TableTextRow'

import { DriverModel } from '@/app/models'
import useFormatDate from '@/modules/drivers/hooks/useFormatDate'
interface DriverContractRowProps {
  driver: DriverModel
  search: string
  onClick?: () => void
  /**
   * False when the driver is neither active nor present in any billable
   * ledger event (timesheet calc, .ddd import, printout) for the current
   * period — the row gets the same gray-out as inactive drivers. Defaults
   * to true so callers that don't pass it preserve previous behavior.
   */ 
  //isCounted?: boolean
}

const DriverContractRow: React.FC<DriverContractRowProps> = ({
  driver,
  search,
  onClick,
  //isCounted = true,
}) => {
  const navigate = useNavigate()
  const location = useLocation()
  const { formatDate } = useFormatDate()
  const { setSelectedDriverId } = useDrivers()

  const [isHovered, setIsHovered] = React.useState(false)

  const isActive = driver?.isActive
  const to = `/driver/${driver.id}`

  const handleMouseEnter = () => setIsHovered(true)
  const handleMouseLeave = () => setIsHovered(false)

  const handleClick = () => {
    if (to) {
      const newPath = `${location.pathname}/${to.replace(/^\//, '')}`
      navigate(newPath)
      onClick && onClick()
    }
    setSelectedDriverId(driver.id)
  }

  const highlightMatch = (text: string, search: string) => {
    if (!search) return text
    const regex = new RegExp(`(${search})`, 'gi')
    const parts = text.split(regex)

    return (
      <div>
        {parts.map((part, index) =>
          regex.test(part) ? (
            <span key={index} className="tw-bg-[#FFF47B]">
              {part}
            </span>
          ) : (
            part
          ),
        )}
      </div>
    )
  }

  return (
    <tr
      className={`notches-border--right tw-w-fit tw-cursor-pointer tw-border-b tw-bg-white hover:tw-bg-primary/10 ${!isActive ? 'tw-opacity-30' : ''}`}
      onClick={handleClick}
      onMouseEnter={handleMouseEnter} 
      onMouseLeave={handleMouseLeave}
    >
      <TableTextRow
        icon={
          <img
            src={UserCardIcon}
            className="tw-text-content-base"
            alt="User Card Icon"
          />
        }
      >
        {highlightMatch(`${driver.surname} ${driver.name}`, search)}
      </TableTextRow>
      <TableTextRow>
        {formatDate(driver?.firstContractStartDate) ?? '-'}
      </TableTextRow>
      <TableTextRow>{driver?.nationality?.name ?? '-'}</TableTextRow>
      <TableTextRow>{driver?.phoneNumber ?? '-'}</TableTextRow>
      <TableTextRow>{driver?.email ?? '-'}</TableTextRow>
    </tr>
  )
}

export default DriverContractRow
